import { render, staticRenderFns } from "./DefaultHeader.ChangeLanguage.vue?vue&type=template&id=1e508b39&scoped=true"
import script from "./DefaultHeader.ChangeLanguage.vue?vue&type=script&lang=js"
export * from "./DefaultHeader.ChangeLanguage.vue?vue&type=script&lang=js"
import style0 from "./DefaultHeader.ChangeLanguage.vue?vue&type=style&index=0&id=1e508b39&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e508b39",
  null
  
)

export default component.exports